import { Injectable, Injector, WritableSignal, signal } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { TasksService } from 'app/api';
import { SaveButtonService } from 'app/core/save-button/save-button.service';
import { TranslationTabService } from 'app/core/translation-tab/translation-tab.service';
import { BusinessProcessTaskService } from 'app/services/bp/business-process.service';
import { ProcessService } from '../bp-management/process.service';
import { ViewFilter } from './dialogs/filter-dialog/filter.model';

@Injectable({ providedIn: 'root' })
export class ViewService extends BusinessProcessTaskService {
    isCreatingScreenshot: WritableSignal<boolean> = signal(false);

    filterModel: WritableSignal<ViewFilter> = signal({
        responsibles: [],
        systems: [],
    });

    currentActionsSignal: WritableSignal<string[]> = signal([]);

    constructor(
        apiService: TasksService,
        saveButtonService: SaveButtonService,
        translationTabService: TranslationTabService,
        translocoService: TranslocoService,
        injector: Injector,
        private processService: ProcessService
    ) {
        super(apiService, saveButtonService, translationTabService, translocoService, injector);
        this.scope = 'bpView';
    }

    override getWbs(id: string): string {
        return this.processService.state.find(p => p.id === id)?.wbs;
    }
}
